module.exports = "/_next/static/images/a501f89c57eebfb81b0faba4ea61e3c6-ticket-01-03.png.webp";